module.exports = __webpack_public_path__ + "static/media/icon-like_.583162e5.svg";